/**
 * The ONE collator for every contract-defined ordering. Pinned to 'en' because
 * the §6.6 sort and search contracts are properties of the PRODUCT, not of the
 * reader's OS: a shared deep link must open to the same row order for the
 * person who sent it and the person who received it. User-locale collation
 * would be correct for a document; it is wrong for a contract.
 *
 * Constructed once at module load so every comparator shares one `Intl.Collator`
 * rather than re-allocating on each `localeCompare` call (O(n log n) lookups
 * per sort at ~560 rows × per-keystroke search).
 */
export const COLLATOR = new Intl.Collator('en', { sensitivity: 'variant' });
